module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.2809/js/img/productIcons/CRM.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/img/productIcons/CRM.svg
// module id = 691
// module chunks = 3 4